/**
 * Doribharat Heritage — Global JavaScript
 * Handles: mobile menu, cart drawer, back-to-top, announcement dismissal
 */

(function () {
    'use strict';

    // ── Mobile Menu Toggle ──
    var menuToggle = document.getElementById('MobileMenuToggle');
    var mobileMenu = document.getElementById('MobileMenu');

    if (menuToggle && mobileMenu) {
        menuToggle.addEventListener('click', function () {
            var isOpen = mobileMenu.classList.toggle('is-open');
            menuToggle.setAttribute('aria-expanded', isOpen);
        });
    }

    // ── Cart Drawer Toggle + Live Rendering ──
    var cartIcon = document.querySelector('[data-cart-toggle]');
    var cartDrawer = document.getElementById('CartDrawer');
    var cartOverlay = document.getElementById('CartOverlay');
    var cartClose = document.getElementById('CartDrawerClose');
    var cartItemsEl = document.getElementById('CartDrawerItems');

    function formatMoney(cents) {
        return 'Rs. ' + (cents / 100).toFixed(2).replace(/\.00$/, '.00');
    }

    function getPreorder(item) {
        return item.properties && item.properties['Pre-order'] ? item.properties['Pre-order'] : '';
    }

    function renderCart(cart) {
        if (!cartItemsEl) return;
        if (!cart.items || cart.items.length === 0) {
            cartItemsEl.innerHTML =
                '<p style="text-align:center;color:var(--color-text-muted);padding:40px 0;">Your bag is empty</p>';
            // Update badge
            var badge = document.getElementById('CartCount');
            if (badge) badge.textContent = '0';
            return;
        }

        var html = '';

        // Shipping note: pre-order lines carry a "Pre-order" property
        // (e.g. "Dispatches after 25 October"). Mixed bags ship in two parts.
        var preorderText = '';
        var hasInStock = false;
        cart.items.forEach(function (item) {
            var p = getPreorder(item);
            if (p) { preorderText = p; } else { hasInStock = true; }
        });
        if (preorderText) {
            var dispatchDate = preorderText.replace(/^Dispatches after\s*/i, '');
            var noteText = hasInStock
                ? 'Your bag has a pre-order item. In-stock items ship now; the pre-order item ships separately after ' + dispatchDate + '.'
                : 'Your bag has pre-order items. They ship after ' + dispatchDate + '.';
            html +=
                '<div style="margin:12px 0 4px;padding:10px 12px;border:1.5px solid var(--color-primary);border-radius:8px;font-size:12px;line-height:1.5;">' +
                '<strong style="color:var(--color-primary);">Shipping note</strong><br>' + noteText +
                '</div>';
        }

        cart.items.forEach(function (item) {
            var img = item.image
                ? item.image.replace(/(\.\w+)(\?|$)/, '_180x$1$2')
                : '';
            var preorder = getPreorder(item);
            html +=
                '<div class="cart-drawer__item" data-cart-key="' + item.key + '" style="display:flex;gap:14px;padding:16px 0;border-bottom:1px solid var(--color-border);transition:opacity .25s,transform .25s,max-height .3s;max-height:200px;overflow:hidden;">' +
                (img
                    ? '<img src="' + img + '" alt="' + item.title + '" style="width:72px;height:72px;object-fit:cover;border-radius:8px;flex-shrink:0;">'
                    : '') +
                '<div style="flex:1;min-width:0;">' +
                '<p style="font-weight:600;font-size:14px;margin:0 0 4px;line-height:1.3;">' + item.product_title + '</p>' +
                (item.variant_title
                    ? '<p style="font-size:12px;color:var(--color-text-muted);margin:0 0 6px;">' + item.variant_title + '</p>'
                    : '') +
                (preorder
                    ? '<p style="font-size:12px;font-weight:700;color:var(--color-primary);margin:0 0 6px;">Pre-order \u00B7 ' + preorder + '</p>'
                    : '') +
                '<div style="display:flex;align-items:center;justify-content:space-between;">' +
                '<span style="font-weight:700;font-size:14px;">' + formatMoney(item.final_line_price) + '</span>' +
                '<span style="font-size:13px;color:var(--color-text-muted);">Qty: ' + item.quantity + '</span>' +
                '</div>' +
                '</div>' +
                '<button onclick="removeCartItem(\'' + item.key + '\')" style="align-self:flex-start;background:none;border:none;cursor:pointer;color:var(--color-text-muted);font-size:18px;padding:0 4px;" aria-label="Remove">&times;</button>' +
                '</div>';
        });

        // Subtotal
        html +=
            '<div style="padding:16px 0;display:flex;justify-content:space-between;font-weight:700;">' +
            '<span>Subtotal</span>' +
            '<span>' + formatMoney(cart.total_price) + '</span>' +
            '</div>';

        cartItemsEl.innerHTML = html;

        // Update badge
        var badge = document.getElementById('CartCount');
        if (badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? '' : 'none';
        }

        // Update footer CTA
        var footerLink = document.querySelector('.cart-drawer__footer a');
        if (footerLink) {
            if (cart.items && cart.items.length > 0) {
                footerLink.href = '/checkout';
                footerLink.textContent = 'Proceed to Checkout';
            } else {
                footerLink.href = '/cart';
                footerLink.textContent = 'View Cart';
            }
        }
    }

    function fetchAndRenderCart() {
        fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(renderCart)
            .catch(function () { });
    }

    // Expose remove function globally — smooth animation
    window.removeCartItem = function (key) {
        // Animate out the item row first
        var row = document.querySelector('[data-cart-key="' + key + '"]');
        if (row) {
            row.style.opacity = '0';
            row.style.transform = 'translateX(40px)';
            row.style.maxHeight = '0';
            row.style.padding = '0';
        }

        // Wait for animation then actually remove
        setTimeout(function () {
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: String(key), quantity: 0 }),
                credentials: 'same-origin',
            })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                    renderCart(cart);
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                });
        }, 300);
    };

    function openCart(e) {
        if (e) e.preventDefault();
        if (cartDrawer) cartDrawer.classList.add('is-open');
        if (cartOverlay) cartOverlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        fetchAndRenderCart();
    }

    function closeCart() {
        if (cartDrawer) cartDrawer.classList.remove('is-open');
        if (cartOverlay) cartOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
    }

    if (cartIcon) cartIcon.addEventListener('click', openCart);
    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    // Re-render cart contents + badge whenever the cart changes
    document.addEventListener('cart:updated', fetchAndRenderCart);

    // Opening the drawer on add is the moment a shopper decides to check out.
    // Previously this refreshed silently, which left them with a 3-second
    // toast and no path forward — only 19% of carts ever reached checkout.
    // openCart() already fetches and renders, so it replaces that refresh
    // rather than running alongside it.
    document.addEventListener('cart:item-added', function () {
        if (cartDrawer) {
            openCart();
        } else {
            fetchAndRenderCart();
        }
    });

    // ── Back to Top ──
    var backToTop = document.getElementById('BackToTop');

    if (backToTop) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 400) {
                backToTop.classList.add('is-visible');
            } else {
                backToTop.classList.remove('is-visible');
            }
        }, { passive: true });

        backToTop.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    // ── Announcement Bar Dismissal ──
    var announcementClose = document.getElementById('AnnouncementClose');
    var announcementBar = document.getElementById('AnnouncementBar');

    if (announcementClose && announcementBar) {
        // Check if previously dismissed
        if (sessionStorage.getItem('announcement_dismissed')) {
            announcementBar.style.display = 'none';
        }

        announcementClose.addEventListener('click', function () {
            announcementBar.style.display = 'none';
            sessionStorage.setItem('announcement_dismissed', 'true');
        });
    }

    // ── Product functions (switchImage, updateQty, switchTab) ──
    // Defined inline in product page snippets to avoid loading on non-product pages

    // ── Intersection Observer for Animations ──
    if ('IntersectionObserver' in window) {
        var animateElements = document.querySelectorAll('[data-animate]');
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-slide-up');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

        animateElements.forEach(function (el) {
            observer.observe(el);
        });
    }

})();
